import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4cbebfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-column align-items-center justify-content-center" }
const _hoisted_2 = { class: "p-inputgroup w-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "チェックをつける: 採時駅", -1))
const _hoisted_4 = { class: "station-chart" }
const _hoisted_5 = { class: "vertical-rl h-5rem" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "vertical-rl" }, "さんぷる", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Inplace = _resolveComponent("Inplace")!
  const _component_Timeline = _resolveComponent("Timeline")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_InputText, {
          placeholder: "駅名",
          modelValue: _ctx.newStationName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newStationName) = $event)),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.onEnter($event.keyCode, _ctx.addStation)), ["enter"]))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_Button, {
          icon: "pi pi-plus",
          onClick: _ctx.addStation,
          label: "駅追加"
        }, null, 8, ["onClick"])
      ])
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_ctx.stationList.stations.length)
        ? (_openBlock(), _createBlock(_component_Timeline, {
            key: 0,
            value: _ctx.stationList.stations,
            layout: "horizontal"
          }, {
            marker: _withCtx((slotProps) => [
              _createVNode(_component_Checkbox, {
                modelValue: slotProps.item.shouldRecordTime,
                binary: true,
                onChange: () => _ctx.changeCheckbox(slotProps.index)
              }, null, 8, ["modelValue", "onChange"])
            ]),
            content: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Inplace, {
                  closable: true,
                  onClose: () => _ctx.changeStationName(slotProps.index),
                  active: _ctx.isOpenStationNameChange[slotProps.index],
                  "onUpdate:active": ($event: any) => ((_ctx.isOpenStationNameChange[slotProps.index]) = $event),
                  class: "block"
                }, {
                  display: _withCtx(() => [
                    _createTextVNode(_toDisplayString(slotProps.item.name), 1)
                  ]),
                  content: _withCtx(() => [
                    _createVNode(_component_InputText, {
                      modelValue: slotProps.item.name,
                      class: "w-6rem",
                      onInput: _ctx.onChangeStationName,
                      onKeydown: _withKeys(($event: any) => (
                    _ctx.onEnter($event.keyCode, () =>
                      _ctx.changeStationName(slotProps.index)
                    )
                  ), ["enter"])
                    }, null, 8, ["modelValue", "onInput", "onKeydown"])
                  ]),
                  _: 2
                }, 1032, ["onClose", "active", "onUpdate:active"])
              ])
            ]),
            _: 1
          }, 8, ["value"]))
        : (_openBlock(), _createBlock(_component_Timeline, {
            key: 1,
            value: [1, 2, 3],
            layout: "horizontal"
          }, {
            content: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }))
    ])
  ], 64))
}